import React from "react";
import _ from "lodash";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from "@mui/material";

const fields = [
  "propertyName",
  "yearBuilt",
  "acres",
  "units",
  "submarket",
  "assetClass",
  "assetType",
  "priorityStatus"
];

function MultiFamilyData({ parcel }) {
  return (
    <Grid container>
      <Grid size={12}>
        <Paper elevation={1}>
          <TableContainer>
            <Table>
              <TableBody>
                {_.map(fields, key => (
                  <TableRow key={key}>
                    <TableCell>
                      <b>{_.startCase(key)}</b>
                    </TableCell>
                    <TableCell>{parcel.multiFamilyData[key]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default MultiFamilyData;
